var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "humidity",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Glyph"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDDAE5",
    d: "M47.03 10a2.194 2.194 0 0 0-1.82.95c-.71 1.01-1.73 2.5-2.87 4.26-2.95-4.78-5.86-9.06-7.84-11.91a3.054 3.054 0 0 0-5 0c-5.67 8.11-18.85 27.98-18.85 37.35a21.348 21.348 0 0 0 42.21 4.53 13.145 13.145 0 0 0 7.29-11.74c0-5.71-7.9-17.63-11.3-22.49a2.22 2.22 0 0 0-1.82-.95ZM32 60a19.371 19.371 0 0 1-19.35-19.35c0-9.05 14.15-30 18.49-36.2a1.057 1.057 0 0 1 1.72 0c4.34 6.2 18.49 27.15 18.49 36.2A19.371 19.371 0 0 1 32 60Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DDDAE5",
    d: "M40.224 23.4a1 1 0 0 0 .87.505.984.984 0 0 0 .494-.132 1 1 0 0 0 .374-1.363 184.044 184.044 0 0 0-3.933-6.56 1 1 0 0 0-1.7 1.062 177.525 177.525 0 0 1 3.895 6.488zM29.38 32.13a6.508 6.508 0 0 0-3.6-.99 6.469 6.469 0 0 0-3.59.99 5.179 5.179 0 0 1-4.25.47.991.991 0 0 0-1.29.55 21.536 21.536 0 0 0-2 7.5 17.35 17.35 0 1 0 34.7 0 21.642 21.642 0 0 0-2.01-7.51 1 1 0 0 0-1.28-.55 5.14 5.14 0 0 1-4.27-.46 7.022 7.022 0 0 0-7.19 0 5.031 5.031 0 0 1-5.22 0zM28 38a3 3 0 1 1-3 3 3.009 3.009 0 0 1 3-3zm8 13a3 3 0 1 1 3-3 3.009 3.009 0 0 1-3 3zm1.32-12.74a1 1 0 1 1 1.36 1.48l-12 11a1 1 0 0 1-1.36-1.48z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 41,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 48,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 26,
    r: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.69c221b4e153ab04d9d82ce8cf97ad73.svg";
export { ForwardRef as ReactComponent };